import { formatOrDefault } from "../../util/date/formatOrDefault";
import { tryParseUtcToLocalDate } from "../../util/date/TimeZone";
import { isNullOrWhiteSpace } from "../../util/functions/isNullOrWhiteSpace";
import { computed, makeObservable } from "mobx";

export class NewsItem {
    constructor(
        public id: number,
        private readonly created: string,
        private readonly updated: string,
        public visible: boolean,
        public header: string,
        public body: string,
        public language: string,
        private readonly from: string, //UTC
        private readonly until: string, //UTC
        public popup: boolean,
        public maintenance: boolean,
        public hoursUpFront: number,
    ) {
        makeObservable(this);
    }
    
    @computed
    public get fromLocalDateTime(): string | null {
        if (isNullOrWhiteSpace(this.from)) return null;
        
        const localDate = tryParseUtcToLocalDate(this.from);
        if (!localDate) return this.from;
        
        return formatOrDefault(localDate, "dd/MM/yyyy HH:mm", this.from);
    }

    @computed
    public get untilLocalDateTime(): string | null {
        if (isNullOrWhiteSpace(this.until)) return null;

        const localDate = tryParseUtcToLocalDate(this.until);
        if (!localDate) return this.until;

        return formatOrDefault(localDate, "dd/MM/yyyy HH:mm", this.until);
    }
}

export interface IPow3NewsItem {
    id: number,
    created: string,
    updated: string,
    visible: boolean,
    header: string,
    body: string,
    language: string,
    from: string, //UTC
    until: string, //UTC
    popup: boolean,
    maintenance: boolean,
    hoursUpFront: number
}
    